package fyi.moko.hotpl.ui

actual val platformSupportsEdgeSwipeBack: Boolean = false
